import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  CircularProgressBarStyled,
  BackgroundCircle,
  ProgressCircle,
} from './styles/CircularProgressBarStyled';

const CircularProgressBar = ({ sqSize, strokeWidth, percentage }) => {
  // SVG centers the stroke width on the radius, subtract out so circle fits in square
  const radius = (sqSize - strokeWidth) / 2;
  // Enclose cicle in a circumscribing square
  const viewBox = `0 0 ${sqSize} ${sqSize}`;
  // Arc length at 100% coverage is the circle circumference
  const dashArray = radius * Math.PI * 2;
  // Scale 100% coverage overlay with the actual percent
  const dashOffset = dashArray - (dashArray * percentage) / 100;
  return (
    <CircularProgressBarStyled width={sqSize} height={sqSize} viewBox={viewBox}>
      <BackgroundCircle
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={strokeWidth}
      />
      <ProgressCircle
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={strokeWidth}
        // Start progress marker at 12 O'Clock
        transform={`rotate(-90.1 ${sqSize / 2}.1 ${sqSize / 2}.1)`}
        style={{
          strokeDasharray: dashArray,
          strokeDashoffset: dashOffset,
        }}
      />
    </CircularProgressBarStyled>
  );
};

CircularProgressBar.propTypes = {
  sqSize: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number.isRequired,
};

CircularProgressBar.defaultProps = {
  sqSize: 200,
  percentage: 25,
  strokeWidth: 10,
};

export default memo(CircularProgressBar);
